// removed by extract-text-webpack-plugin
module.exports = {"circle":"_1lOqJ","path":"_9176d"};


//////////////////
// WEBPACK FOOTER
// ./src/App/AppLogo.css
// module id = 490
// module chunks = 3